var styles = {"article":"SkeletonArea-module_article__AjomK","type-page":"SkeletonArea-module_type-page__94LHw","is-alpha50":"SkeletonArea-module_is-alpha50__ITsnN"};

export { styles as default };
